export const rect = function (ctx : any) {
    ctx.save();
    ctx.strokeStyle = "rgba(0,0,0,0)";
    ctx.miterLimit = 4;   
    ctx.save();
    ctx.beginPath();
    ctx.moveTo(86, 23);
    ctx.lineTo(115, 23);
    ctx.bezierCurveTo(115, 23, 115, 23, 115, 23);
    ctx.lineTo(115, 177);
    ctx.bezierCurveTo(115, 177, 115, 177, 115, 177);
    ctx.lineTo(86, 177);
    ctx.bezierCurveTo(86, 177, 86, 177, 86, 177);
    ctx.lineTo(86, 23);
    ctx.bezierCurveTo(86, 23, 86, 23, 86, 23);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.restore();
}